<span class="filter-headline">
  {{ 'general.staff_filter' | translate }}
</span>
<div class="d-flex flex-grow-1 align-items-center justify-content-between">
  <wilson-user-shift-assignment-availability-filter></wilson-user-shift-assignment-availability-filter>

  <wilson-show-qualifed-staff-checkbox></wilson-show-qualifed-staff-checkbox>

  <wilson-display-qualified-working-time-checkbox></wilson-display-qualified-working-time-checkbox>
</div>
